import { useCreateCommendaAiConversation } from '@commenda/ui/commenda-ai/useCreateCommendaAiConversation';
import { useChatPanel } from 'context/useChatPanel';

/** Create-on-send for the panel: the new conversation becomes the active one in place, where the
 * full page would navigate to it. */
export const useChatPanelConversation = () => {
  const { setActiveConversationId } = useChatPanel();
  const { createConversation } = useCreateCommendaAiConversation({
    onCreated: setActiveConversationId,
  });

  return { startConversation: createConversation };
};
